(function ($) {

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    var windowWidth = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == windowWidth) return;
        windowWidth = $(window).width();
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });


//check if overflow slider reached start or end. Add / remove classes -start, -end
    function checkScrollPosition() {
        let $slider = $('[check-scroll]');
        let $arrow = $('[check-scroll-arrow]');
        if (!$slider.length) {
            return;
        }
        $slider.each(function(){
            const scrollLeft = $(this).scrollLeft();
            const scrollWidth = $(this)[0].scrollWidth;
            const clientWidth = $(this)[0].clientWidth;

            if (scrollLeft === 0){
                $(this).addClass('-start');
            } else {
                $(this).removeClass('-start');
            }

            if (scrollLeft + clientWidth >= scrollWidth - 1) {
                $(this).addClass('-end');
            } else {
                $(this).removeClass('-end');
            }
        })

        if ($arrow.length) {
            const scrollLeft = $slider.scrollLeft();
            const scrollWidth = $slider[0].scrollWidth;
            const clientWidth = $slider[0].clientWidth;
            if (clientWidth >= scrollWidth - 50){
                $arrow.hide();
            }
            $arrow.click(function () {
                if (scrollLeft + clientWidth >= scrollWidth - 50) {
                    $slider.scrollLeft(clientWidth);
                } else {
                    $slider.scrollLeft(scrollLeft + 50);
                }
            })
        }
    }

    $(document).gp_ready(function () {
        checkScrollPosition();
        if ($('[check-scroll]').length) {
            $('[check-scroll]').on('scroll', checkScrollPosition);
        }
    });


})(jQuery);
